import {
    BottomNavigation,
    BottomNavigationAction,
    IconButton
} from '@mui/material';
import {
    Home,
    QrCodeScanner,
    Search,
    History,
    Logout,
    AccountCircle
} from '@mui/icons-material';
import AttendanceHome from './AttendanceHome';
import AttendanceScanner from './AttendanceScanner';
import ManualSearch from './ManualSearch';
// import ViewStatistics from './ViewStatistics';
import LogoutHomeScreen from './LogoutHomeScreen';
import Menus from '../../../components/Dialog/Menus';
import RecentScans from './RecentScans';
import LogoutFooter from './LogoutFooter';
import NotFound from '../../../pages/404/NotFound';
import AttendanceSkeleton from './AttendanceSkeleton';
import useEventAttendance from './hooks/useEventAttendance';
import { FooterLogo } from '../../../assets/images';
import { Body3 } from '../../../themes/typography';
import "../../../styles/event/EventAttendance.css";

export default function EventAttendance() {

    const {
        eventStatus,
        data,
        error,
        loading,
        activeTab,
        setActiveTab,
        formatEventDates,
        formatEventTiming,
        countdown,
        isCountdownActive,
        startQRScanner,
        videoRef,
        closeCamera,
        isCameraOn,
        isCameraInitializing,
        openModalAndSetVariant,
        closeModal,
        scanResult,
        openScanResultModal,
        scanResultData,
        checkInGuestByTicketId,
        viewDetailsTab,
        rejectGuestByTicketId,
        onViewTicketDetails,
        viewDetailsData,
        detailsLoading,
        onBackToViewDetails,
        processLoaderType,
        open,
        anchorEl,
        onScanningMenuClose,
        onScanningMenuClick,
        getAttendeesRecentHistory,
        recentScans,
        onBackFromRecentScans,
        showRecentScans,
        onRecentScanSearch,
        isCheckInStaffLoggedIn,
        onCheckInStaffLogout,
        manualSearchTerm,
        onManualTicketSearch,
        manualSearchLoading,
        manualSearchResult,
        openManualSearchModalType,
        onManualResultDismiss,
        onChangeManualSearch,
        onManualSearchCheckIn,
        onManualSearchReject,
        onViewManualSearchTicketDetails
    } = useEventAttendance();


    const menusList = [
        {
            id: 'recent-scans',
            icon: <History color="tertiary" />,
            menuName: 'Recent Scans',
            onClick: () => getAttendeesRecentHistory()
        },
        {
            id: 'view-statistics',
            icon: <History color="tertiary" />,
            menuName: 'View Statistics',
            onClick: () => getAttendeesRecentHistory()
        },
        {
            id: 'terms-conditions',
            icon: <Logout color="tertiary" />,
            menuName: 'Terms & Conditions',
            onClick: () => window.open('/pages/terms-and-conditions', '_blank')
        },
        {
            id: 'privacy-policy',
            icon: <Logout color="tertiary" />,
            menuName: 'Privacy Policy',
            onClick: () => window.open('/pages/privacy-policy', '_blank')
        },
        {
            id: 'contact-us',
            icon: <Logout color="tertiary" />,
            menuName: 'Contact Us',
            onClick: () => window.open('/pages/contact-us', '_blank')
        },
        {
            id: 'logout',
            icon: <Logout color="tertiary" />,
            menuName: 'Logout',
            onClick: () => onCheckInStaffLogout()
        },
    ];


    if (loading) {
        return <AttendanceSkeleton />;
    }

    if (error) {
        return (
            <div className="page-view">
                <div className='page-wrapper'>
                    <NotFound
                        statusCode={error.code}
                        pageTitle="Something went wrong!"
                        description="We're having trouble loading the event details. Please try again later."
                        shouldShowBgGradient={false}
                    />
                </div>
            </div>
        )
    }


    return (
        <div className="event-attendance-container">

            <div className="event-attendance-wrapper">

                <header className="event-attendance-header">

                    <div className='platform-logo-containers'>
                        <div className='platform-logo-wrapper'>
                            <img src={FooterLogo} alt="Shmooz Logo" />
                        </div>
                    </div>

                    {isCheckInStaffLoggedIn && (
                        <div className='event-name-chip'>
                            <IconButton
                                color="elipsis"
                                onClick={onScanningMenuClick}
                                aria-controls={open ? 'scanning-actions' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                sx={{ padding: '0' }}
                            >
                                <AccountCircle color='tertiary' sx={{ fontSize: '1.75rem' }} />
                            </IconButton>
                            <Menus
                                id="scanning-menus"
                                open={open}
                                anchorEl={anchorEl}
                                onClick={onScanningMenuClose}
                                onClose={onScanningMenuClose}
                                menus={menusList}
                                shouldShowIcons={false}
                                shouldShowDividerAtLast={true}
                                isLogoutMenu={true}
                            />
                        </div>
                    )}
                </header>

                <div className='empty-header'></div>


                {isCheckInStaffLoggedIn && (
                    <main className="event-attendance-main">

                        {showRecentScans && (
                            <RecentScans
                                onBack={onBackFromRecentScans}
                                onSearch={onRecentScanSearch}
                                data={recentScans}
                                loading={processLoaderType === 'recentScans' && detailsLoading}
                            />
                        )}

                        {/* <ViewStatistics /> */}

                        {activeTab === 0 && !showRecentScans && (
                            <AttendanceHome
                                data={data}
                                formatEventDates={formatEventDates()}
                                formatEventTiming={formatEventTiming()}
                                countdown={countdown}
                                isCountdownActive={isCountdownActive}
                                eventStatus={eventStatus}
                            />
                        )}

                        {activeTab === 1 && !showRecentScans && (
                            <AttendanceScanner
                                startQRScanner={startQRScanner}
                                videoRef={videoRef}
                                closeCamera={closeCamera}
                                isCameraOn={isCameraOn}
                                isCameraInitializing={isCameraInitializing}
                                openModalAndSetVariant={openModalAndSetVariant}
                                closeModal={closeModal}
                                scanResult={scanResult}
                                openScanResultModal={openScanResultModal}
                                scanResultData={scanResultData}
                                onCheckIn={checkInGuestByTicketId}
                                onViewDetails={onViewTicketDetails}
                                onBackTicketDetails={onBackToViewDetails}
                                viewDetailsTab={viewDetailsTab}
                                onReject={rejectGuestByTicketId}
                                detailsLoading={detailsLoading}
                                viewDetailsData={viewDetailsData}
                                processLoaderType={processLoaderType}
                                isCountDownActive={isCountdownActive}
                                eventStatus={eventStatus}
                            />
                        )}

                        {activeTab === 2 && !showRecentScans && (
                            <ManualSearch
                                onManualTicketSearch={onManualTicketSearch}
                                searchTerm={manualSearchTerm}
                                loading={manualSearchLoading}
                                manualSearchResult={manualSearchResult}
                                openModal={openManualSearchModalType}
                                onDismiss={onManualResultDismiss}
                                onSearchInputChange={onChangeManualSearch}
                                onCheckIn={onManualSearchCheckIn}
                                detailsLoading={detailsLoading}
                                processType={processLoaderType}
                                onReject={onManualSearchReject}
                                onViewTicket={onViewManualSearchTicketDetails}
                                isViewDetailActive={viewDetailsTab}
                                viewDetailsData={viewDetailsData}
                                onBack={onBackToViewDetails}
                                isCountDownActive={isCountdownActive}
                            />
                        )}

                    </main>
                )}

                {!isCheckInStaffLoggedIn && (
                    <main className="event-attendance-main">
                        <LogoutHomeScreen />
                    </main>
                )}


                {(isCheckInStaffLoggedIn && !showRecentScans) && (
                    <>
                        <div className='empty-footer'></div>
                        <footer className="event-attendance-footer">
                            <BottomNavigation
                                showLabels
                                value={activeTab}
                                onChange={(event, newValue) => setActiveTab(newValue)}
                                sx={{
                                    backgroundColor: 'transparent',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    gap: '1rem',
                                }}
                            >
                                <BottomNavigationAction
                                    label={<Body3 fontWeight={400}>Home</Body3>}
                                    icon={<Home color="white" />}
                                    sx={{
                                        backgroundColor: activeTab === 0 ? 'var(--secondary-color)' : 'transparent',
                                        borderRadius: '1rem',
                                        maxWidth: '100px',
                                        padding: '0'
                                    }}
                                />
                                <BottomNavigationAction
                                    label={<Body3 fontWeight={400}>Scanner</Body3>}
                                    icon={<QrCodeScanner color="white" />}
                                    sx={{
                                        backgroundColor: activeTab === 1 ? 'var(--secondary-color)' : 'transparent',
                                        borderRadius: '1rem',
                                        maxWidth: '100px',
                                        padding: '0'
                                    }}
                                />
                                <BottomNavigationAction
                                    label={<Body3 fontWeight={400}>Search</Body3>}
                                    icon={<Search color="white" />}
                                    sx={{
                                        backgroundColor: activeTab === 2 ? 'var(--secondary-color)' : 'transparent',
                                        borderRadius: '1rem',
                                        maxWidth: '100px',
                                        padding: '0'
                                    }}
                                />
                            </BottomNavigation>
                        </footer>
                    </>
                )}

                {!isCheckInStaffLoggedIn && (
                    <>
                        <div className='empty-footer'></div>
                        <footer className="event-attendance-footer" style={{ padding: '0.875rem' }}>
                            <LogoutFooter />
                        </footer>
                    </>
                )}

            </div>

        </div>
    )
}